import{REQUEST_MENU,RECEIVE_MENU,ERROR_MENU}from"../../constants/ActionTypes";/**
 * Creates the dispatched REQUEST_MENU action object.
 * @param {string} id The menu id.
 * @return {Object} The dispatched action object.
 */export var requestMenu=function requestMenu(id){return{type:REQUEST_MENU,id:id};};/**
 * Creates the dispatched RECEIVE_MENU action object
 * @param {string} id The menu id.
 * @param {Array} entries The menu entries.
 * @return {Object} The dispatched action object.
 */export var receiveMenu=function receiveMenu(id,entries){return{type:RECEIVE_MENU,id:id,entries:entries};};/**
 * Creates the dispatched ERROR_MENU action object.
 * @param {string} id The menu id.
 * @return {Object} The dispatched action object.
 */export var errorMenu=function errorMenu(id){return{type:ERROR_MENU,id:id};};